<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime blagajne *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.electronic_device_id"
          label="Oznaka blagajne *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.electronic_device_id.required)"
        >
          <FormErrorsLine v-if="!$v.form.electronic_device_id.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
            :items="decimalsPlacesOptions"
            v-model="form.decimal_places"
            label="Št. decimalnih mest"
          ></v-select>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    device: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      decimalsPlacesOptions: [2, 3, 4],
      form: {
        name: null,
        electronic_device_id: null,
        decimal_places: 2
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      electronic_device_id: {
        required
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.form, ...this.device }
  }
}
</script>
